export const CCLS_MODULE = '/modules/activate'
